module.exports = __webpack_public_path__ + "static/img/icon_zanwuwdpx@2x.6fe778bc.png";